<template>
	<div class="haq-field haq-field--textarea">
		<label v-if="label" class="haq-field__label">{{ label }}</label>
		<v-textarea
			class="haq-field__control"
			outlined
			dense
			:hide-details="hideDetails"
			v-bind="$attrs"
			:value="value"
			v-on="listeners"
		>
			<template v-for="(_, name) in $scopedSlots" #[name]="slotData">
				<slot :name="name" v-bind="slotData" />
			</template>
		</v-textarea>
	</div>
</template>

<script>
/**
 * Standard outlined textarea with an external label (no floating Vuetify label).
 */
export default {
	name: 'HaqTextarea',
	inheritAttrs: false,
	props: {
		/** v-model value */
		value: {
			type: [String, Number],
			default: null,
		},
		/** External label shown above the field */
		label: {
			type: String,
			default: '',
		},
		/** Vuetify hide-details; use false or 'auto' when showing validation */
		hideDetails: {
			type: [Boolean, String],
			default: 'auto',
		},
	},
	computed: {
		/**
		 * Forward listeners and map input for v-model.
		 * @returns {Object}
		 */
		listeners() {
			return {
				...this.$listeners,
				input: (val) => this.$emit('input', val),
			};
		},
	},
};
</script>
